import { computedFrom, customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { uuidv4 } from 'framework/script_utilities/uuid-generator';

@customElement('as-widget-list')
export class WidgetList {
  @bindable items: WidgetItem[];
  @bindable defaultKind: string = null;
  @bindable handlerClass = `__handler-${uuidv4()}`;
  @bindable removable = true;
  @bindable reorderable = false;
  @bindable disabled = false;
  @bindable hideLastRemove = false;
  @bindable hideListGutter = false;

  removeItem(item: WidgetItem) {
    this.items.splice(this.items.indexOf(item), 1);
  }

  reorderItem(item: WidgetItem, index: number) {
    this.items.splice(index, 0, ...this.items.splice(this.items.indexOf(item), 1));
  }

  @computedFrom('handlerClass')
  get handlerSelector() {
    return `.${this.handlerClass}`;
  }
}

export interface WidgetItem {
  kind?: string;
}
